import React, { useState } from "react";
import CreateOrUpdateTransitVisaModal from "../../../../components/modal/visa/CreateOrUpdateTransitVisaModal";
import Button1 from "../../../../components/form/Button1";

function CreateVisaButton() {
  const [modal, setModal] = useState(false);

  return (
    <div>
      <CreateOrUpdateTransitVisaModal open={modal} setOpen={setModal} />
      <Button1 className="w-fit" onClick={() => setModal(true)}>
        Create new transit visa
      </Button1>
    </div>
  );
}

export default CreateVisaButton;
